import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import FilterButton from "../../../components/Common/FilterButton";
import Button from "sushiweb/Button";
import SettlementProcessesList from "../../../components/DriverAccounting/SettlementProcesses/SettlementProcessesList";
import SettlementProcessFormModal from "../../../components/DriverAccounting/SettlementProcesses/SettlementProcessesFormModal";
import ListPagination from "../../../components/Common/ListPagination";
import * as DriverAccountingActions from "../../../store/actions/DriverAccounting";
import Permission from "../../../components/Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import { FlexContainer, Heading } from "../../../constants/assets/containers";
import { isMobile } from "../../../utils";

const SettlementProcesses = (props) => {
  const [modalState, setModalState] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.DRIVER_ACCOUNTING];

  const filterFields = ["start_date", "end_date"];

  const handleClick = (type, id) => {
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  // handle pagination
  const handleNavClick = (action) => {
    const pageRequest = { page_number: currentPage };
    if (action === "prev") {
      pageRequest.page = currentPage - 1;
    } else {
      pageRequest.page = currentPage + 1;
    }
    setCurrentPage(pageRequest.page);
    props.getSettlementProcesses(
      props.activeSettlementProcessesFilters,
      pageRequest
    );
  };

  const handleTriggerNextEvent = (id) => {
    props.triggerNextEvent(id).then((res) => {
      const pageRequest = { page_number: currentPage };
      props.getSettlementProcesses(
        props.activeSettlementProcessesFilters,
        pageRequest
      );
    });
  };

  const getModal = () => {
    const defaultProps = {
      modalState: modalState,
      handleClose: handleClose,
      settlementProcessesList: props.settlementProcessesList,
    };

    switch (modalState) {
      case "Add":
        return (
          <SettlementProcessFormModal
            {...defaultProps}
            heading="Add Settlement Process"
          />
        );
      case "Filter":
        return (
          <SettlementProcessFormModal
            {...defaultProps}
            filterFields={filterFields}
            heading="Filter Settlement Processes"
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    props.getSettlementProcesses();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeSettlementProcessesFilters)]);

  return (
    <SettlementProcessContainer className="DriverAccounting-SettlementProcesses-View container">
      <FlexContainer>
        <Heading>Settlement process </Heading>
        <div
          style={{ maxWidth: "320px" }}
          className="actionBar mb-20 flex items-center justify-end"
        >
          <Permission requiredPerms={[allActions.SETTLEMENT_PROCESS_LIST]}>
            <FilterButton
              activeFilters={props.activeSettlementProcessesFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.SETTLEMENT_PROCESS_WRITE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-16"
              appearance="outline"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[allActions.SETTLEMENT_PROCESS_LIST]}>
        <SettlementProcessesList
          settlementProcessesList={props.settlementProcessesList}
          handleTriggerNextEventClick={(id) => handleTriggerNextEvent(id)}
        />
        <ListPagination
          nextPage={props.nextPage}
          prevPage={props.prevPage}
          handleNavClick={handleNavClick}
        />
      </Permission>
      {modalState && getModal()}
    </SettlementProcessContainer>
  );
};

const SettlementProcessContainer = styled.div`
  & > div {
    align-items: ${isMobile() ? "flex-start" : "center"};
    .actionBar {
      margin-left: ${isMobile() ? "unset" : "auto"};
      margin-top: ${isMobile() ? "10px" : "unset"};
    }
  }
`;

const mapStateToProps = (state) => {
  const { DriverAccounting } = state;
  return {
    settlementProcessesList: DriverAccounting.settlementProcessesList,
    activeSettlementProcessesFilters:
      DriverAccounting.activeSettlementProcessesFilters,
    prevPage: DriverAccounting.prevPage,
    nextPage: DriverAccounting.nextPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSettlementProcesses: bindActionCreators(
      DriverAccountingActions.getSettlementProcesses,
      dispatch
    ),
    triggerNextEvent: bindActionCreators(
      DriverAccountingActions.triggerNextEvent,
      dispatch
    ),
    setCurrentPage: bindActionCreators(
      DriverAccountingActions.setCurrentPageSettlementProcess,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettlementProcesses);
